module.exports = __webpack_public_path__ + "static/media/secondaryAccountImage.3a7ea532.png";